export default function isPinnedApp() {
  if (typeof window !== 'undefined') {
    return (
      window.navigator.standalone ||
      window.matchMedia('(display-mode: standalone)').matches
    )
  }
}
